import styled from "styled-components";
import Box from "@mui/material/Box";

const StyledBox = styled(Box)(({ theme }) => ({
  position: "fixed",
  transform: "translate(-1px, 42px)",
  width: "30vw",
  outline: 'none',
  backgroundColor: "var(--Surface-Base-Secondary-Subdued, #F6F9FA)",
  border: "none",
  boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.20), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
  inset: "0px 0px auto auto",
  p: 4,
  overflow: "hidden",
  height: "auto",
  fontFamily: "Source Sans Pro",
  fontSize: 14,
  fontStyle: "normal",
  fontWeight: 400,
  "& *": {
    fontFamily: "inherit",
  },
}));
export { StyledBox };
